import { Component, computed, input } from '@angular/core';
import { KENDO_CARD, KENDO_GRIDLAYOUT } from '@progress/kendo-angular-layout';
import { ClientDetailedDto } from '@unity/clients';
import { DateTimezonePipe } from '@unity/pipes/date-timezone.pipe';
import { CardSummarySharedComponent } from '../composed/card-summary-shared/card-summary-shared.component';

@Component({
  selector: 'unity-card-client-agreement-duration-summary-shared',
  standalone: true,
  imports: [KENDO_CARD, KENDO_GRIDLAYOUT, CardSummarySharedComponent, DateTimezonePipe],
  templateUrl: './card-client-agreement-duration-summary-shared.component.html',
  styleUrl: './card-client-agreement-duration-summary-shared.component.scss',
})
export class CardClientAgreementDurationSummarySharedComponent {
  public readonly $client = input.required<ClientDetailedDto | undefined>({ alias: 'client' });
  public readonly $isLoading = input.required<boolean>({ alias: 'isLoading' });

  protected readonly $agreementDuration = computed(() => {
    const client = this.$client();
    if (!client) {
      return;
    }

    const start = new Date(client.start_date);
    const end = new Date(client.end_date ?? new Date());

    // 1. Count full months
    const months = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth()) + 1;

    return `${months} month${months === 1 ? '' : 's'}`;
  });
}
